import React from 'react';
import { Application } from '@yulintu/freesia-bootstrap';

const Icon = function (props) {
    return <Application.SvgIcon type="a-userset-fill" style={{ fontSize: 26 }} />;
}

export default Icon;